@if (isAuthorized | async) {
  <button class="dropdown-item"
    [routerLink]="['/items', contextMenuObject.id, 'orcid']"
    [innerHTML]="'context-menu.actions.orcid-view' | translate">
  </button>
}
